import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';
import SIBanner from '../../assets/Image/si-2024-banner.png';
import RETBanner from '../../assets/Image/ret-2024-banner.png';

function HomeImageCarousel() {
  return (
      <Carousel prevIcon={<span className="glyphicon glyphicon-arrow-right"></span>} fade>
        <Carousel.Item interval={10000}>
            <a href={"/programs/summer-institute"}>
          <Image width={1050} height={500} src={SIBanner} fluid />
            </a>
        {/*<Carousel.Caption>*/}
        {/*  <h3>First slide label</h3>*/}
        {/*  <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>*/}
        {/*</Carousel.Caption>*/}
      </Carousel.Item>
        <Carousel.Item interval={15000}>
            <a href={"/programs/ret"}>
                <Image width={1050} height={500} src={RETBanner} fluid/>
            </a>
                {/*<Carousel.Caption>*/}
                {/*  <h3>Second slide label</h3>*/}
                {/*  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>*/}
                {/*</Carousel.Caption>*/}
        </Carousel.Item>
        {/*<Carousel.Item>*/}
        {/*  <ExampleCarouselImage text="Third slide" />*/}
      {/*  <Carousel.Caption>*/}
      {/*    <h3>Third slide label</h3>*/}
      {/*    <p>*/}
      {/*      Praesent commodo cursus magna, vel scelerisque nisl consectetur.*/}
      {/*    </p>*/}
      {/*  </Carousel.Caption>*/}
      {/*</Carousel.Item>*/}
    </Carousel>
  );
}

export default HomeImageCarousel;
